import { AiUserQuestionaryField } from "@scrile/api-provider/dist/api/AiUserQuestionaryProvider";
import { getFormattedDate } from "@/lib/dateTimeHelpers";
import { $t } from "@/lib/i18nHelpers";
import { FormFields } from "@/types";

export const fields: FormFields = [
  { name: "character", type: "subtitle", label: $t("Character") },
  {
    name: AiUserQuestionaryField.NAME,
    type: "text",
    label: $t("Name"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.BIRTHDAY,
    type: "date",
    minDate: getFormattedDate(new Date(0)),
    label: $t("Birthday"),
    rules: ["required"],
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.AGE,
    type: "text",
    label: $t("Age"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.NATIONALITY,
    type: "text",
    label: $t("Nationality"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.APPEARANCE,
    type: "text",
    label: $t("Appearance"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.HEIGHT,
    type: "text",
    label: $t("Height"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.WEIGHT,
    type: "text",
    label: $t("Weight"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.EYE_COLOR,
    type: "text",
    label: $t("Eye color"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.SHOE_SIZE,
    type: "text",
    label: $t("Shoe size"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.TRAITS_OF_CHARACTER,
    type: "text",
    label: $t("Traits of character"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.HOBBY,
    type: "text",
    label: $t("Hobby"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.JOB,
    type: "text",
    label: $t("Job"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.WHY_LIKE_JOB,
    type: "text",
    label: $t("Why do you like your job?"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.PRIORITY_IN_LIFE,
    type: "text",
    label: $t("Priority in life"),
    rules: "required",
    validationMode: "aggressive",
  },
  { name: "facts", type: "subtitle", label: $t("Facts") },
  {
    name: AiUserQuestionaryField.SPORT,
    type: "text",
    label: $t("What sport do you do?"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.ADDRESS,
    type: "text",
    label: $t("Where do you live?"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.NATIVE_LANGUAGE,
    type: "text",
    label: $t("Native language (mother tongue)"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.WEAR,
    type: "text",
    label: $t("What do you usually wear?"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.SLEEP_IN,
    type: "text",
    label: $t("What do you sleep in?"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.COUNTRIES_VISITED,
    type: "text",
    label: $t("What countries did you travel to?"),
    rules: "required",
    validationMode: "aggressive",
  },
  { name: "favorites", type: "subtitle", label: $t("Favorites") },
  {
    name: AiUserQuestionaryField.MOVIES,
    type: "text",
    label: $t("Movies"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.BOOKS,
    type: "text",
    label: $t("Books"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.MUSIC,
    type: "text",
    label: $t("Music"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.FOOD,
    type: "text",
    label: $t("Food"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.FAVORITE_COUNTRIES,
    type: "text",
    label: $t("Country to travel"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.ALCOHOL,
    type: "text",
    label: $t("Alcohol"),
    rules: "required",
    validationMode: "aggressive",
  },
  { name: "communication", type: "subtitle", label: $t("Communication") },
  {
    name: AiUserQuestionaryField.ENJOY_TALKING_ABOUT,
    type: "text",
    label: $t("What do you enjoy talking about"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.COMMUNICATION_STYLE,
    type: "text",
    label: $t("Communication style"),
    rules: "required",
    validationMode: "aggressive",
  },
  { name: "socialMedia", type: "subtitle", label: $t("Social media, web") },
  {
    name: AiUserQuestionaryField.INSTAGRAM,
    type: "text",
    label: $t("Instagram"),
    rules: "required",
    validationMode: "aggressive",
  },
  {
    name: AiUserQuestionaryField.WEBSITE,
    type: "text",
    label: $t("Website"),
    rules: "required",
    validationMode: "aggressive",
  },
];
